export default __webpack_public_path__ + "static/media/carousel-2.7e508d0a.png";